export const SET_CURRENT_ECHO = 'SET_CURRENT_ECHO'
export const SET_ECHO_LOADING = 'SET_ECHO_LOADING'
